import $ from "jquery";
import { CountUp } from 'countup.js'; 

// Store the CountUp instance globally so we can update it
let countUpAnim;

function dropDownMenu() {
    const optionMenu = document.querySelector(".select-menu");
    if (!optionMenu) return;

    const selectBtn = optionMenu.querySelector(".select-btn"),
        options = optionMenu.querySelectorAll(".option"),
        sBtn_text = optionMenu.querySelector(".sBtn-text");

    selectBtn.addEventListener("click", () => optionMenu.classList.toggle("active"));

    options.forEach(option => {
        if (option.classList.contains('active')) {
            sBtn_text.innerText = option.querySelector('.option-text').textContent;
        }
        option.addEventListener("click", (e) => {
            e.preventDefault();
            const repayentFrequency = e.currentTarget.getAttribute("data-value");
            $(".js-refi-frequency").val(parseInt(repayentFrequency));
            sBtn_text.innerText = option.querySelector(".option-text").innerText;
            optionMenu.classList.remove("active");
            
            // Run calculator after a tiny delay for better UI feel
            setTimeout(() => runRefiCalculator(), 100);
        });
    });
}

function calculateTotalInterest(principal, rate, term, frequency) {
    // Calculate the periodic interest rate
    const r = rate / 100 / frequency;
    const n = term * frequency;
    
    // Calculate the periodic payment using mortgage formula
    const payment = (principal * r) / (1 - Math.pow(1 + r, -n));
    
    // Total amount paid over the loan term
    const totalPaid = payment * n;
    
    // Total interest is total paid minus the principal
    const totalInterest = totalPaid - principal;
    
    return totalInterest;
}

function runRefiCalculator() {
    // 1. Get and Clean Values
    const loan = parseFloat($(".js-refi-loan").val().replace(/,/g, "")) || 0;
    const currentRate = parseFloat($(".js-refi-current-rate").val().replace(/,/g, "")) || 0;
    const newRate = parseFloat($(".js-refi-new-rate").val().replace(/,/g, "")) || 0;
    const term = parseFloat($(".js-refi-term").val().replace(/,/g, "")) || 0;
    const frequency = parseInt($(".js-refi-frequency").val()) || 52; // Default to weekly

    // 2. Update the loan term display dynamically
    $(".js-loan-term-display").text(term || "0");

    if (loan <= 0 || currentRate <= 0 || newRate <= 0 || term <= 0) {
        // Update display to 0 if inputs are invalid
        if (countUpAnim) {
            countUpAnim.update(0);
        }
        return;
    }

    // 3. Calculate total interest over remaining term at current rate
    const currentInterestTotal = calculateTotalInterest(loan, currentRate, term, frequency);
    
    // 4. Calculate total interest over remaining term at new rate
    const newInterestTotal = calculateTotalInterest(loan, newRate, term, frequency);
    
    // 5. Calculate interest savings over the full remaining term
    const interestSavings = currentInterestTotal - newInterestTotal;

    // 6. Round to 2 decimal places
    const finalValue = Math.round(interestSavings * 100) / 100;

    // 7. Animate the Result
    if (!countUpAnim) {
        countUpAnim = new CountUp('js-refi-result', finalValue, {
            duration: 0.8,
            separator: ',',
            decimal: '.',
            decimalPlaces: 2,
            startVal: 0
        });

        if (!countUpAnim.error) {
            countUpAnim.start();
        } else {
            console.error(countUpAnim.error);
            $("#js-refi-result").text(finalValue.toLocaleString('en-NZ', {minimumFractionDigits: 2, maximumFractionDigits: 2}));
        }
    } else {
        // If it already exists, just update the target number
        countUpAnim.update(finalValue);
    }
}

/* ===============================
   FORMATTING HELPER
================================ */
function formatNumberWithCommas(el) {
    // 1. Get current value and cursor position
    let value = el.val();
    let originalSelectionStart = el[0].selectionStart;
    
    // 2. Remove all non-numeric characters (except the decimal for rates)
    let isRateField = el.hasClass('js-refi-current-rate') || el.hasClass('js-refi-new-rate');
    let cleanValue = isRateField 
        ? value.replace(/[^0-9.]|\.(?=.*\.)/g, "") 
        : value.replace(/\D/g, "");

    if (cleanValue === "") {
        el.val("");
        return;
    }

    // 3. Format with commas
    let parts = cleanValue.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    let formattedValue = parts.join(".");

    // 4. Only update if the value actually changed (prevents cursor jumping)
    if (value !== formattedValue) {
        el.val(formattedValue);
        
        // 5. Logic to keep cursor in the right place
        let diff = formattedValue.length - value.length;
        el[0].setSelectionRange(originalSelectionStart + diff, originalSelectionStart + diff);
    }
}

/* ===============================
   UPDATED EVENTS
================================ */
function events() {
    $(document).on("input", ".js-number-input", function() {
        // First, format the appearance of the input
        formatNumberWithCommas($(this));
        runRefiCalculator();
    });
}

// Initial Load
$(window).on('load', function() {
    if ($(".calculator_refinance").length) {
        dropDownMenu();
        events();
        runRefiCalculator();
    }
});